import { render } from "./DocumentClassSearchMask.vue?vue&type=template&id=f55516fa&ts=true"
import script from "./DocumentClassSearchMask.vue?vue&type=script&lang=ts"
export * from "./DocumentClassSearchMask.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__